import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import VideoIntro from "@/components/landing/VideoIntro";
import ValueProps from "@/components/landing/ValueProps";
import Journey from "@/components/landing/Journey";
import Author from "@/components/landing/Author";
import Testimonials from "@/components/landing/Testimonials";
import CtaBanner from "@/components/landing/CtaBanner";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div
      data-testid="landing-root"
      className="relative min-h-screen bg-[#0a0a0a] text-neutral-200 overflow-x-hidden"
    >
      <Nav />
      <main>
        <Hero />
        <VideoIntro />
        <ValueProps />
        <Journey />
        <Author />
        <Testimonials />
        <CtaBanner />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
